import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

function renderValue(value, suffix = '') {
  if (value == null || value === '') return 'N/D';
  return `${value}${suffix}`;
}

function FoodEducationSheetModal({ open, sheet, onClose }) {
  if (!open || !sheet) return null;

  return (
    <div className="fixed inset-0 z-[85] bg-black/50 p-3 sm:p-6" onClick={onClose}>
      <div className="mx-auto flex h-full max-w-3xl items-end sm:items-center" onClick={(event) => event.stopPropagation()}>
        <Card className="w-full max-h-[92vh] overflow-y-auto">
          <CardHeader>
            <div className="flex items-center justify-between gap-2">
              <div>
                <CardTitle>{sheet.nom}</CardTitle>
                <CardDescription>Fiche educative et nutritionnelle</CardDescription>
              </div>
              <Badge className="bg-amber-100 text-amber-800">A savoir</Badge>
            </div>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-slate-700">
            <p>{sheet.description}</p>
            <p><strong>Utilite nutritionnelle:</strong> {sheet.utiliteNutritionnelle}</p>
            <p><strong>Origine:</strong> {sheet.origine}</p>
            <p><strong>Interets potentiels:</strong> {sheet.interetsSante}</p>
            <p><strong>Risques / precautions:</strong> {sheet.risquesPrecautions}</p>
            <p><strong>Conservation:</strong> {sheet.conservation}</p>
            <p><strong>Duree de conservation:</strong> {sheet.dureeConservation}</p>
            <p><strong>Bien choisir:</strong> {sheet.choixProduit}</p>
            <p><strong>Idees d utilisation:</strong> {sheet.usages}</p>
            <p><strong>Recettes rapides:</strong> {Array.isArray(sheet.recettesRapides) ? sheet.recettesRapides.join(' • ') : sheet.recettesRapides}</p>
            <p><strong>Remarques pratiques:</strong> {sheet.remarques}</p>
            <p><strong>A savoir:</strong> {sheet.aSavoir}</p>

            <div className="rounded-xl border border-slate-200 p-3">
              <p className="mb-2 font-semibold text-slate-900">Tableau nutritionnel (pour 100 g)</p>
              <div className="grid grid-cols-2 gap-2 text-xs sm:grid-cols-3">
                <div>Calories: {renderValue(sheet.nutrition100g?.calories, ' kcal')}</div>
                <div>Proteines: {renderValue(sheet.nutrition100g?.proteines, ' g')}</div>
                <div>Glucides: {renderValue(sheet.nutrition100g?.glucides, ' g')}</div>
                <div>Sucres: {renderValue(sheet.nutrition100g?.sucres, ' g')}</div>
                <div>Fibres: {renderValue(sheet.nutrition100g?.fibres, ' g')}</div>
                <div>Lipides: {renderValue(sheet.nutrition100g?.lipides, ' g')}</div>
                <div>Graisses saturees: {renderValue(sheet.nutrition100g?.graisses_saturees, ' g')}</div>
                <div>Sodium / sel: {renderValue(sheet.nutrition100g?.sodium, ' g')}</div>
                <div>Indice glycemique: {renderValue(sheet.nutrition100g?.indice_glycemique)}</div>
                <div>Omega-3: {renderValue(sheet.nutrition100g?.omega3, ' g')}</div>
              </div>
            </div>

            <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-xs text-red-800">
              <strong>Avertissement medical:</strong> {sheet.medicalWarning}
            </div>

            {sheet.sourceNote && (
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700">
                <strong>Reference:</strong> {sheet.sourceNote}
              </div>
            )}

            <div className="flex justify-end">
              <Button type="button" onClick={onClose}>Fermer</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default FoodEducationSheetModal;
